import React from 'react';
import PropTypes from 'prop-types';

import { FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import { Button } from 'onefaceui-react-components';
import { TextField } from 'react/components/fields';
import Loading from 'react/components/Loading';

function SectionsSection({ loadingInitialValues }) {
  const onClickAction = (e) => {
    e.preventDefault();

    Greenmile.Survey.Form.createNewSection();
  };

  return (
    <FormSection className="surveySections" title="Survey.form.sectionsSection">
      <FormSectionColumn>
        <TextField
          label="surveySections"
          name="surveySections"
          shouldShow={false}
          doNotShowOnGrid
          fieldCriteria={[
            '*',
            'surveySections.*',
            'surveySections.surveyQuestions.*',
            'surveySections.surveyQuestions.entity.*',
            'surveySections.surveyQuestions.nextQuestion.*',
            'surveySections.surveyQuestions.nextSection.*',
            'surveySections.surveyQuestions.surveyQuestionDomain.*',
            'surveySections.surveyQuestions.surveyQuestionDomain.nextQuestion.*',
            'surveySections.surveyQuestions.surveyQuestionDomain.nextQuestion.surveySection.*',
            'surveySections.surveyQuestions.surveyQuestionDomain.nextSection.*',
            'surveySections.surveyQuestions.surveyQuestionDomain.sku.*',
            'surveySections.surveyQuestions.subQuestions.*',
            'surveySections.surveyQuestions.subQuestions.entity.*',
            'surveySections.surveyQuestions.subQuestions.nextQuestion.*',
            'surveySections.surveyQuestions.subQuestions.nextSection.*',
            'surveySections.surveyQuestions.subQuestions.surveyQuestionDomain.*',
            'surveySections.surveyQuestions.subQuestions.surveyQuestionDomain.nextSection.*',
            'surveySections.surveyQuestions.subQuestions.surveyQuestionDomain.nextQuestion.*',
            'surveySections.surveyQuestions.subQuestions.surveyQuestionDomain.nextQuestion.surveySection.*',
            'surveySections.surveyQuestions.subQuestions.surveyQuestionDomain.sku.*'
          ]}
        />

        <div className="sectionContainer" />

        {loadingInitialValues
          ? (<Loading width="30px" height="30px" theme="blue" />)
          : (
            <Button className="addItem" onClick={onClickAction}>
              {Monet.I18n.getResourcesByKey('Survey.form.btn.sectionButton')}
            </Button>
          )}

      </FormSectionColumn>
    </FormSection>
  );
}

SectionsSection.propTypes = {
  loadingInitialValues: PropTypes.bool
};

export default SectionsSection;
